import {
  Box,
  Collapse,
  Icon,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { collapseArrow, collapseIconBox, collapseItem, collapseText } from "./Styles";

const CollapseMenu = ({ open, active, children, name, icon, minSideNav, ...rest }) => {
  return (
    <>
      <ListItem {...rest}>
        <Box
          sx={(theme) =>
            collapseItem(theme, {
              active,
            })
          }
        >
          <ListItemIcon sx={(theme) => collapseIconBox(theme)}>{icon}</ListItemIcon>
          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav: minSideNav,
                active: active,
              })
            }
          />
          <Icon
            sx={(theme) =>
              collapseArrow(theme, {
                miniSidenav: minSideNav,
                open: open,
                active: active,
              })
            }
          >
            expand_less
          </Icon>
        </Box>
      </ListItem>
      {children && (
        <Collapse in={open} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
};

export default CollapseMenu;
